module.exports = __webpack_public_path__ + "img/youzhi.e8a4a57f.jpg";